<template>
  <v-card v-resize="onResize" class="fill-height" >
    
    <v-tabs
      hide-slider
      :grow="!$vuetify.breakpoint.xsOnly"
      show-arrows
      class="fill-height"
      :color="focused && $store.state._User.connexionType != 'freshdesk' 
        ? 'accent' : focused && $store.state._User.connexionType == 'freshdesk'
          ? 'grey lighten-2'
          : 'grey lighten-4'"
      :dark="focused && $store.state._User.connexionType != 'freshdesk'"
      v-model="tab.href"
    >
      <v-tab
        v-for="item in filteredItems"
        :key="item.href"
        :href="'#' + item.href"
        @click="checkTab(item)"
        :disabled="item.disabled.status"
        :title="item.title"
      >
        <v-icon
          size="24"
          :color="tab.href === item.href
            ? 'secondary'
            : item.disabled.status
              ? 'grey'
              : focused && $store.state._User.connexionType !== 'freshdesk'
                ? 'white'
                : 'grey darken-2'"
        >
          {{ item.icone }}
        </v-icon>
      </v-tab>
      <!-- <v-tabs-items style="height: calc(100% - 48px)"> -->
        <v-tab-item
          v-for="item in itemsMenu"
          :key="item.href"
          :value="item.href"
          class="vb fill-height"
          :ref="`tab-item-${item.href}`"
          v-bar
        >
          <v-card
            flat
            height="100%"
            width="calc(100% - 20px)"
            class="contentFicheVisiteur"
            :class="{'cobrowsing--container': item.href == 'mirroring' || item.href == 'cobrowsing'}"
          >
            <component
              v-if="tab.href === item.href && item.show"
              :is="item.component"
              class="fill-height tab-item__component"

              :datasVisiteur="datasVisiteur"
              :datasPupitreVisiteur="datasPupitreVisiteur"
              
              :params="'visId=' + datasVisiteur.visiteurID"
              :toolbar="true"
              :navigation="true"
              chatHeight="100%"
              numChatsTotal="0"
              type="chatting"
              colorChatAgent="grey lighten-1"
              colorChatVisiteur="grey"
              
              :hauteurDiv.sync="hauteurDiv"
              @closeCobrowsing="annuleCobrowsing(); tab = itemsMenu[0]"

              @closeDialog="tab = itemsMenu[0]"
              @startVisioAPZ="startVisio"
              @stopVisioAPZ="stopVisio"

              @cacheInfosVisiteur="cacheInfosVisiteur()"
              openOnMounted
              
              @put="msg => $emit('update:msg', msg)"
              @send="msg => $emit('sendMsg', msg)"
              @pushproduct="msg => $emit('sendMsg', msg)"
            ></component>
          </v-card>
        </v-tab-item>
        <v-btn
          class="btnCloseFicheInfos"
          v-if="$vuetify.breakpoint.xsOnly"
          icon
          small
          @click="cacheInfosVisiteur()"
        >
          <v-icon large>arrow_circle_right</v-icon>
        </v-btn>
      <!-- </v-tabs-items> -->
    </v-tabs>
    
    <!-- dialog reconnexion -->
    <v-dialog v-model="dialogDemandeCobrowsing" persistent max-width="290">
      <v-card>
        <v-card-title class="primary white--text subheading">{{$t('titleAskCobrowsing')}}</v-card-title>
        <v-card-text>
          {{ txtDemandeCobrowsing }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
            class="blue--text darken-1" flat @click="annuleCobrowsing(); tab = itemsMenu[0]">{{txtBtCobrowsing}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex'
import Cobrowsing from '../watcheebox/cobrowsing.js'
import WzFicheInfosVisiteur from './WzFicheInfosVisiteur'
import WzFicheLeadVisiteur from './WzFicheLeadVisiteur'
import WzFicheBiblioPhrases from './WzFicheBiblioPhrases'
import WzFichePushProduit from './WzFichePushProduit'
import WzHistoChats from '../watcheezy/WzHistoChats'
import WzHistoBot from '../watcheezy/WzHistoBot'
import WzCobrowsingClient from './WzCobrowsingClient'
import WzDialogTransfertChat from './WzDialogTransfertChat'
import WzDialogBannishVisitor from './WzDialogBannishVisitor'
// import WzIframeExtension from './WzIframeExtension'
// import WzGpt from './WzGpt'
import WzVisioVente from './WzVisioVente'
// import WebrtcExtension from './WebrtcExtension'
// import WebrtcAPZ from './WebrtcAPZ'
import _ from 'lodash'
import { LEVEL } from '../../constants.js'
export default {
  components: {
    WzCobrowsingClient,
    WzFicheInfosVisiteur,
    WzFicheBiblioPhrases,
    WzFichePushProduit,
    WzVisioVente,
    WzFicheLeadVisiteur,
    WzHistoChats,
    WzHistoBot
  },
  data () {
    return {
      hauteurDiv: 0,
      dialogDemandeCobrowsing: false,
      txtBtCobrowsing: this.$t('cancel'),
      txtDemandeCobrowsing: '',
      /**
       * @type {Object}
       * Permet de gérer les événements liés au cobrowsing
       */
      cobrowsing: null,
      /**
       * Indique le tab sélectionné
       */
      tab: { href: '' }
    }
  },

  props: ['datasVisiteur', 'datasPupitreVisiteur', 'placesPupitre'],

  methods: {
    ...mapActions('_Notifier', ['NEW_NOTIF']),
    ...mapMutations('_StoreWatcheeBox', [
      'SET_STATUS_COBROWSING',
      'SET_VISITEURS'
    ]),
    // test le status de la bride pour afficher le menu
    testBrideStatus (name) {
      // console.log('name', name)
      let brides = this.$store.state._User.brides
      // console.log('brides', brides)
      if (brides) {
        let resultat = brides.find(brides => brides.brideName === name)
        if (resultat) {
          if (resultat.status === '0') {
            return true
          } else {
            return false
          }
        }
      }
      // console.log('resultat', resultat)
    },
    // ----------------------------------------------------------------------------
    // ouvre automatiquement l'onglet de screensharing
    // ----------------------------------------------------------------------------
    openScreensharing (visiteurId) {
      console.log('open screensharing ', visiteurId)
      this.tab.href = 'visioApz'
    },
    // ----------------------------------------------------------------------------
    // l'agent annule la demande de cobrowsing
    // ----------------------------------------------------------------------------
    annuleCobrowsing () {
      console.log('-> annuleCobrowsing')
      this.dialogDemandeCobrowsing = false
      this.SET_STATUS_COBROWSING({
        placePupitre: this.datasVisiteur.placePupitre,
        status: false
      })
      var agentSocketID = this.WATCHEEBOX_STATE.mySocketID
      // envois de la demande de cobrowsing au visiteur
      this.cobrowsing = new Cobrowsing()
      if (this.cobrowsing) {
        this.cobrowsing.demandeCobrowsing({
          active: false,
          agentSocketID: agentSocketID,
          datasAgent: this.user,
          datasVisiteur: this.datasVisiteur
        })
      }
    },
    cacheInfosVisiteur () {
      this.$emit('cacheInfosVisiteur')
    },
    // ----------------------------------------------------------------------------
    // l'agent envoit une demande cobrowsing au visiteur
    // ----------------------------------------------------------------------------
    checkCobrowsingAutorisation () {
      console.log('-> check Cobrowsing autorisation')
      if (!this.datasVisiteur.reponseCobrowsing) {
        // pas de session cobrowsing, on lance la demande
        this.sendDemandeCobrowsing()
      }
    },

    // ----------------------------------------------------------------------------
    // l'agent envoit une demande cobrowsing au visiteur
    // ----------------------------------------------------------------------------
    sendDemandeCobrowsing () {
      console.log('-> sendDemandeCobrowsing')
      this.dialogDemandeCobrowsing = true
      this.txtBtCobrowsing = this.$t('cancel')
      // phrase par defaut
      this.txtDemandeCobrowsing = this.$t('contentAskCobrowsing')
      var agentSocketID = this.WATCHEEBOX_STATE.mySocketID
      this.SET_STATUS_COBROWSING({
        placePupitre: this.datasVisiteur.placePupitre,
        status: false
      })
      // envois de la demande de cobrowsing au visiteur
      this.cobrowsing = new Cobrowsing()
      this.cobrowsing.demandeCobrowsing({
        active: true,
        agentSocketID: agentSocketID,
        datasAgent: this.user,
        datasVisiteur: this.datasVisiteur,
        placePupitre: this.datasVisiteur.placePupitre
      })
    },

    onResize () {
      this.hauteurDiv = this.$el.offsetHeight - 100
    },

    /**
     * envois d'un message sur le chat mais uniquement online ou busy
     */
    sendMessage (msg) {
      if (this.$route.fullPath !== '/trafic/attente' && this.$route.fullPath !== '/trafic/contact' && !this.directChat) {
        // sur les autres pages, pas d'envois de message offline
        if (this.status === 'offline') {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('currentlyOffline'),
            context: 'error'
          })
          return
        }
        // sinon 'online' ou 'busy' envois message
        this.$emit('sendMsg', msg)
        // this.$emit('send', { message: msg.message })
      }
    },

    /**
     * Affiche une info si le tab n'est pas clickable
     */
    checkTab (item) {
      // console.log('checkTab', item)
      // console.log('this.tab.href', this.tab.href)
      // console.log('item.href', item.href)

      // Vérifie que l'onglet est actif
      if (item.disabled.status) {
        this.NEW_NOTIF({
          message: this.$t(item.disabled.raison),
          context: 'error'
        })
      }
    },

    /**
     * Sélection de l'onglet par défaut :
     * ne peut être le bannissement
     * par défaut il devient le premier
     */
    selectTab () {
      let tab = this.itemsMenu.find(
        t => t.href === this.datasVisiteur.menuSelected
      )
      if (tab && tab.href !== 'banish') {
        if (tab.href === 'transfertChat') {
          if (this.transfertStatusEmission.status === 'wait') {
            this.tab = tab
          } else {
            this.tab = this.itemsMenu[0]
          }
        } else {
          this.tab = tab
        }
      } else {
        this.tab = this.itemsMenu[0]
      }
    },

    // -------------------------------------------------
    // démarrage de la visioconf
    // -------------------------------------------------
    startVisio (data) {
      console.log('start visio', this.sessionVisioconf.confURL)
      console.log('start visio 2', this.$store.state._StoreWatcheeBox.sessionVisioconf.confURL)
      // si il y a deja des infos de visioconf en cours
      if (this.sessionVisioconf.confURL) {
        console.log('store user', this.sessionVisioconf)
      } else {
        // et on notifi le visiteur
        this.sendMessage({message: 'Rejoignez-moi en visioconférence ici : ' + data.url})
      }
    },
    // -------------------------------------------------
    // arret de la visioconf
    // -------------------------------------------------
    stopVisio (data) {
      // this.$emit('stopVisio')
      // on efface les infos du store
      // this.DEL_SESSION_VISIOCONF()
      this.$store.commit('_StoreWatcheeBox/DEL_SESSION_VISIOCONF')
      this.sendMessage({message: 'Fin de la visio-assistance'})
    }
  },

  watch: {
    'datasVisiteur.reponseCobrowsing': function (val, oldVal) {
      console.log('checkReponseCobrowsing', val)
      if (val) {
        this.dialogDemandeCobrowsing = false
      } else {
        this.txtDemandeCobrowsing = this.$t('visitorNoCobrowsing')
        this.txtBtCobrowsing = this.$t('close')
      }
    },

    'transfertStatusEmission.status': function (val, oldVal) {
      if (val === 'wait' && this.transfertStatusEmission.datas.chatSession === this.datasVisiteur.visiteurID) {
        this.tab.href = 'transfertChat'
      }
    },

    placesPupitre () {
      this.onResize()
    },

    'tab.href': function (newVal, oldVal) {
      let tab = this.itemsMenu.find(t => t.href === newVal)
      if (!tab) {
        return
      }
      if (!tab.scroll) {
        const ref = this.$refs[`tab-item-${tab.href}`][0]
        this.$vuebar.destroyScrollbar(ref.$el)
      }
      let visiteur = _.cloneDeep(this.datasVisiteur)
      // Indique l'état du cobrowsing au store, selon l'onglet choisi
      let statusCobrowsing = false
      if (tab.href === 'mirroring' || tab.href === 'cobrowsing') {
        statusCobrowsing = true
      }
      if (tab.href === 'cobrowsing') {
        this.checkCobrowsingAutorisation()
      } else {
        visiteur.reponseCobrowsing = false
        // this.annuleCobrowsing()
      }
      this.SET_STATUS_COBROWSING({
        placePupitre: this.datasVisiteur.placePupitre,
        status: statusCobrowsing
      })
      visiteur.menuSelected = newVal
      this.SET_VISITEURS(visiteur)
    },

    'datasVisiteur.visiteurID': function (newVal, oldval) {
      this.selectTab()
    }
  },

  mounted () {
    this.onResize()
  },

  created () {
    this.selectTab()
    if (this.transfertStatusEmission.status === 'wait' && this.transfertStatusEmission.datas.chatSession === this.datasVisiteur.visiteurID) {
      this.tab.href = 'transfertChat'
    }
    // this.annuleCobrowsing() // envois une annulation de cobrowsing au visiteur en cas de rechargement de l'agent pour effacer la demande chez le visiteur
  },
  computed: {
    ...mapState('_StoreWatcheeBox', [
      'listeAllVisiteurs',
      'lastMessage',
      'transfertStatusEmission',
      'mySocketID',
      'demandeCobrowsing',
      'focusPupitre',
      'agentsArray',
      'status',
      'sessionVisioconf'
    ]),
    ...mapGetters('_StoreWatcheeBox', ['WATCHEEBOX_STATE']),
    ...mapState('_Sites', ['sites']),
    ...mapState('_User', ['entLevel']),
    ...mapGetters('_Sites', ['GET_SITE_BY_ID']),
    ...mapGetters('_User', ['user', 'level']),

    checkSessionVisiconf () {
      if (this.sessionVisioconf.confURL) {
        // si c'est bien avec ce visiteur
        if (this.sessionVisioconf.visiteur.visiteurID === this.datasVisiteur.visiteurID) {
          return true
        }
      }
      return false
    },
    /**
     * Vérifie la possibilité de lancer du mirroring ou du cobrowsing
     */
    check () {
      // console.log('this.datasVisiteur', this.datasVisiteur)
      let site = this.GET_SITE_BY_ID(this.datasVisiteur.siteID)
      // console.log('site', site)
      if (!site) {
        return { status: true, raison: 'error' }
      }
      let checked = {
        status: false,
        raison: ''
      }
      // if (site.LIC_COBROWSING_ACTIVATED === '0') {
      //   checked = { status: true, raison: 'warningCobrowsingDisabled' }
      // } else if (
      if (
        this.datasVisiteur.network &&
        this.datasVisiteur.network !== undefined
      ) {
        checked = { status: true, raison: 'networkVisitor' }
      } else if (!this.datasVisiteur.socketID) {
        checked = { status: true, raison: 'visitorNoSocket' }
        // } else if (!this.mirroringMenuActif) {
        // checked = { status: true, raison: 'inUse' }
      } else {
        if (this.datasPupitreVisiteur.visiteurDatas) {
          // marche pas si pas https
          if (
            this.datasPupitreVisiteur.visiteurDatas.pagesFocus &&
            this.datasPupitreVisiteur.visiteurDatas.pagesFocus.indexOf(
              'http://'
            ) === 1
          ) {
            // marche pas si pas https
            checked = { status: true, raison: 'notHttps' }
          } else {
            checked = { status: false }
          }
        } else {
          checked = { status: true, raison: 'noDataVisiteur' }
        }
      }
      // console.log('return check', checked)
      return { site: site, ...checked }
    },

    checkReponseCobrowsing () {
      // return this.datasVisiteur.reponseCobrowsing
    },

    /**
     * check que le mirroring est bien possible
     * pour ce visiteur et pour le site sur lequel il navigue
     */
    checkMirroring () {
      let checked = this.check
      console.log('checked mirroring', this.check)
      console.log('checked mirroring', this.myStatus)
      if (checked.site.DSK_MIRRORING === '0') {
        checked = { status: true, raison: 'warningMirroringSettingDisabled' }
      } else if (!this.myStatusCobrowsing) {
        checked = { status: true, raison: 'cobrowsingOffline' }
      }
      return checked
    },

    /**
     * check que le cobrowsing est bien possible
     * pour ce visiteur et pour le site sur lequel il navigue
     */
    checkCobrowsing () {
      let checked = this.check
      // console.log('checked cobrowsing', this.check)
      if (checked.site.DSK_COBROWSING === '0') {
        checked = { status: true, raison: 'warningMirroringSettingDisabled' }
      } else if (!this.myStatusCobrowsing) {
        checked = { status: true, raison: 'cobrowsingOffline' }
      }
      return checked
    },

    /**
     * check que le transfert est bien possible
     * pour ce visiteur et pour le site sur lequel il navigue
     */
    checkTransfert () {
      let checked = this.check
      if (this.entLevel === '10' || this.entLevel === '1') {
        // checked = { status: true, raison: 'warningMirroringSettingDisabled' }
        checked = { status: true, raison: this.$tc('notLevelRights', this.level.title, {count: this.level.title}) }
      }
      return checked
    },

    checkIframeExtension () {
      if (this.level.rights !== LEVEL.ENTREPRISE) {
        return { status: true, raison: this.$tc('notLevelRights', this.level.title, {count: this.level.title}) }
      }
      let site = this.GET_SITE_BY_ID(this.datasVisiteur.siteID)
      if (!site || site.DSK_EXTENSION_ONOFF !== '1') {
        return { status: true, raison: 'error' }
      }
      return false
    },

    checkWebrtcExtension () {
      if (this.$store.state._User.connexionType === 'apizee' || this.$store.state._User.apz === '1') {
        return true
      } else {
        return false
      }
    },

    checkKetB () {
      if (this.$store.state._User.ketb === 1) {
        return false // pour un v-show
      } else {
        return true
      }
    },
    /**
     * Construction du menu de la fiche visiteur
     */
    itemsMenu () {
      let menus = []
      /**
       * indique le contexte par défaut :
       * - agent pas sur la page monitoring
       * - visiteur pas sur autre network
       */
      const defaultContext = !this.monitoringRoute && !this.fromAnotherNetwork

      let visitorCard = {
        title: this.$t('visitorCard'),
        href: 'visitorCard',
        component: WzFicheInfosVisiteur,
        icone: 'account_box',
        disabled: false,
        show: true,
        scroll: true
      }
      let conversationHistory = {
        title: this.$t('conversationHistory'),
        href: 'conversationHistory',
        component: WzHistoChats,
        icone: 'forum',
        disabled: false,
        show: true,
        scroll: true
      }
      // let botHistory = {
      //   title: this.$t('botHistory'),
      //   href: 'botHistory',
      //   component: WzHistoBot,
      //   icone: 'adb',
      //   disabled: false,
      //   show: true,
      //   scroll: true
      // }
      // let mirroring = !this.attenteRoute && !this.fromAnotherNetwork && {
      //   title: 'Voir la navigation de l’internaute en temps réel sur votre site',
      //   href: 'mirroring',
      //   component: WzCobrowsingClient,
      //   icone: 'phonelink',
      //   disabled: this.checkMirroring,
      //   show: this.$socket && this.$socket.connected,
      //   scroll: false
      // }
      let visitorEditing = defaultContext && {
        title: this.$t('visitorEditing'),
        href: 'visitorEditing',
        component: WzFicheLeadVisiteur,
        icone: 'create',
        disabled: false,
        show: true,
        scroll: true
      }
      let quickSentences = !this.monitoringRoute && {
        title: this.$t('quickSentences'),
        href: 'quickSentences',
        component: WzFicheBiblioPhrases,
        icone: 'collections_bookmark',
        disabled: false,
        show: true,
        scroll: true
      }
      // let productTitle = !this.monitoringRoute && {
      //   title: this.$t('productTitle'),
      //   href: 'productTitle',
      //   component: WzFichePushProduit,
      //   icone: 'shopping_cart',
      //   disabled: false,
      //   show: this.checkKetB,
      //   scroll: true
      // }
      // let visioVente = !this.monitoringRoute && {
      //   title: this.$t('visioVente'),
      //   href: 'visioVnete',
      //   component: WzVisioVente,
      //   icone: 'group',
      //   disabled: false,
      //   show: true,
      //   scroll: true
      // }
      // let cobrowsing = !this.attenteRoute && defaultContext && {
      //   title: 'Cobrowsing',
      //   href: 'cobrowsing',
      //   component: WzCobrowsingClient,
      //   icone: 'open_in_browser',
      //   disabled: this.checkCobrowsing,
      //   show:
      //     this.$socket &&
      //     this.$socket.connected &&
      //     !this.dialogDemandeCobrowsing,
      //   scroll: false
      // }
      let transfertChat = !this.attenteRoute && defaultContext && {
        title: _.upperFirst(this.$t('toTransfer')),
        href: 'transfertChat',
        component: WzDialogTransfertChat,
        icone: 'transfer_within_a_station',
        disabled: this.checkTransfert,
        show: this.$socket && this.$socket.connected,
        scroll: true
      }
      let banish = defaultContext && {
        title: _.upperFirst(this.$t('banish')),
        href: 'banish',
        component: WzDialogBannishVisitor,
        icone: 'block',
        disabled: false,
        show: this.checkKetB,
        scroll: true
      }
      // let iframeExtension = defaultContext && {
      //   title: _.upperFirst(this.$t('extension')),
      //   href: 'extension',
      //   component: WzIframeExtension,
      //   icone: 'extension',
      //   disabled: this.checkIframeExtension,
      //   show: true,
      //   scroll: false
      // }
      /*
      let Webrtc = defaultContext && {
        title: 'Partage d\'écran',
        href: 'visio',
        component: WebrtcExtension,
        icone: 'screen_share',
        disabled: this.checkWebrtcExtension,
        show: true,
        scroll: false
      }
      */
      // let WebrtcApz = defaultContext && {
      //   title: 'Proposer à l’internaute de partager tout ou partie de son écran',
      //   href: 'visioApz',
      //   component: WebrtcAPZ,
      //   icone: 'screen_share',
      //   disabled: this.checkWebrtcExtension,
      //   show: true,
      //   scroll: false
      // }
      // let gptExtension = defaultContext && {
      //   title: 'Conseiller augmenté',
      //   href: 'gpt',
      //   component: WzGpt,
      //   icone: 'flutter_dash',
      //   disabled: this.testBrideStatus('proposed_ai'),
      //   show: true,
      //   scroll: false
      // }

      // Ajout des menus
      // console.log('visitorEditing', visitorEditing)
      visitorCard && menus.push(visitorCard)
      visitorEditing && menus.splice(1, 0, visitorEditing)
      transfertChat && menus.push(transfertChat)
      // productTitle && menus.push(productTitle)
      // visioVente && menus.push(visioVente)
      banish && menus.push(banish)
      if (this.checkWebrtcExtension) {
        // Webrtc && menus.push(Webrtc)
        // WebrtcApz && menus.push(WebrtcApz)
      }
      // if (!this.testBrideStatus('parametre_cobrowsing_screensharing_apz')) {
      //   WebrtcApz && menus.push(WebrtcApz)
      // }
      if (!this.$vuetify.breakpoint.xsOnly) {
        conversationHistory && menus.push(conversationHistory)
        // botHistory && menus.push(botHistory)
        // mirroring && menus.push(mirroring)
        quickSentences && menus.splice(2, 0, quickSentences)
        // cobrowsing && menus.push(cobrowsing)
        // iframeExtension && menus.push(iframeExtension)
        // gptExtension && menus.push(gptExtension)
      }
      // console.log('menus', menus)
      return menus
    },
    /**
     * Indique si le composant est focus
     */
    focused () {
      return this.focusPupitre.focusSessionID === this.datasVisiteur.visiteurID
    },
    /**
     * Indique si le visiteur provient d'un autre network
     * Facebook par exemple
     */
    fromAnotherNetwork () {
      // console.log('this.datasVisiteur.network', this.datasVisiteur.network)
      if (this.datasVisiteur.network !== 'facebook' && this.datasVisiteur.network !== 'whatsapp') {
        return false
      } else if (this.datasVisiteur.network === 'moon') {
        return true
      } else {
        return true
      }
      // return (
      //   this.datasVisiteur.network && this.datasVisiteur.network.trim().length
      // )
    },
    // sur la page monitoring
    monitoringRoute () {
      return this.$route.fullPath === '/trafic/monitoring'
    },
    // sur la page message en attente
    attenteRoute () {
      return this.$route.fullPath === '/trafic/attente'
    },
    // retourne mon status en ligne
    myStatus () {
      if (this.status === 'online') {
        return true
      } else {
        return false
      }
    },
    // retourne mon status en ligne pour le mirroring/cobrowsing
    // ils sont désactivé uniquement si hors ligne
    myStatusCobrowsing () {
      if (this.status === 'online' || this.status === 'busy') {
        return true
      } else {
        return false
      }
    },
    filteredItems () {
      return this.itemsMenu.filter(item => item.show) // Filtre les éléments avant le v-for
    }
  }
}
</script>

<style scoped>
  .btnCloseFicheInfos {
    right: 0px;
    position: relative;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/watcheebox/WzContentInfosVisiteur.vue